// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"76":"common","415":"details","945":"dashboard"}[chunkId] + "-legacy." + {"76":"163c34a6","415":"9cc407bd","945":"68877e04"}[chunkId] + ".js";
};